import { Box, Typography } from "@mui/material";

const NoCoachesFoundMessage = (): React.JSX.Element => (
  <Box
    sx={{
      backgroundColor: "#eeeeee",
      mb: 2,
      p: 2,
      borderRadius: 2,
    }}
  >
    <Typography variant="h6">Keine Coaches gefunden</Typography>
  </Box>
);

export default NoCoachesFoundMessage;
